import React from 'react';
import Image from 'next/image';
import { LivestreamingRoomData } from '@/types';

interface PageHeaderProps {
  className?: string;
  roomData?: LivestreamingRoomData;
  showDetails?: boolean;
}

const PageHeader = ({ className = '', roomData, showDetails }: PageHeaderProps) => {
  return (
    <section
      className={`page-header ${className} ${showDetails ? 'has-details' : ''}`}
      data-lk-theme="default"
    >
      <div className="logo">
        <Image
          style={{ userSelect: 'none' }}
          priority
          src="/images/logo.svg"
          width={193}
          height={28}
          alt="Gotedo Streams Logo"
        />
      </div>
      <div className="page-header-details">
        {showDetails && roomData && (
          <>
            <h2>{roomData && roomData.room_name}</h2>
            <p>{roomData && roomData.church_name}</p>
          </>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
